// extracted by mini-css-extract-plugin
export default {"container":"container__5J6y7","pageContainer":"pageContainer__fa-VP"};